import { render, staticRenderFns } from "./AddShortCourseBundle.vue?vue&type=template&id=543b1cc2&"
import script from "./AddShortCourseBundle.vue?vue&type=script&lang=js&"
export * from "./AddShortCourseBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports